// JavaScript Document

// jQuery
(function ($) {
  $(function () {

    let $window_height;
    let $slider_adaptive;
    let $slider_adaptive_news;
    let $body = $('body');
    let $window = $(window);
    let $search = $('.botline');
    let $nav = $('nav');
    let $header = $('header');
    let $footer = $('footer');

    mask();
    form_validate();
    setTimeout(function () {
      onloadCallback();
    }, 1000);

    $('[data-bxslider]').each(function (index, element) {
      let $this = $(element);
      let count = $this.find('.item').length;
      let data = $this.data('bxslider');

      data.onSliderLoad = function () {
        $this.find('.name').css({ 'margin-left': $this.parents('.bx-wrapper').find('.bx-pager').innerWidth() + 'px' });
      };
      if (count > 1) slider = $this.bxSlider(data);
    });

    $window.on('resize load', function () {
      if ($window.width() < 660) {
        $('[data-bxslider-s]:not(.active)').addClass('active').each(function (index, element) {
          let $this = $(element),
            count = $this.find('.item').length,
            data = $this.data('bxslider-s');

          if (count > 1) slider = $this.bxSlider(data);
        });
      }
    });

    // Клик
    $body.on('click', '[data-click]', function () {
      let data = $(this).data('click');

      actions(data, this);
      if ($(this).is('a')) return false;
    });

    // Иконки в навигации
    $('[data-icon]').each(function () {
      let $this = $(this),
        icon = $this.data('icon');

      if (icon.length) $this.prepend('<div><img src=\'' + icon + '\' alt=\'\'></div>');
    });

    if (window.location.hash.length && $(window.location.hash + '-scroll').length) {
      $body.animate({ scrollTop: $(window.location.hash + '-scroll').offset().top }, 'slow');
    }

    $('.context').each(function (index, element) {
      let $this = $(element).find('hr');

      $this.before('<p id="context-iveco-link-' + index + '"><a class="link-more hide show-s" data-click=\'{".context-iveco-' + index + '":{"toggle":"slide"}, "#context-iveco-link-' + index + '":{"toggle":"slide"}}\' href="#">Подробнее</a></p>');
      $this.nextAll().wrap('<div class="hide-s context-iveco-' + index + '"></div>');
      $this.remove();
    });

    // Закрепить строку поиска
    $window.on('resize load', function () {
      $window_height = $(this).height();

      // Слайдер текстовых блоков на титульной
      if ($window.width() <= 660 && $('.text-block .bxSlider:not(.active)').length) {
        $slider_adaptive = $('.text-block .bxSlider:not(.active)').addClass('active').bxSlider({
          controls: false,
          adaptiveHeight: true,
        });
      }
      // Слайдер новостей на титульной
      if ($window.width() <= 660 && $('.news-block .bxSlider:not(.active)').length) {
        $slider_adaptive_news = $('.news-block .bxSlider:not(.active)').addClass('active').bxSlider({
          controls: false,
          adaptiveHeight: true,
        });
      }
      // Удаление слайдеров на титульной
      if ($window.width() > 660 && $('.text-block .bxSlider.active').length) {
        $slider_adaptive.removeClass('active').destroySlider();
        $slider_adaptive_news.removeClass('active').destroySlider();
        $('.text-block .bxSlider, .text-block .bxSlider .item').removeAttribute('style');
      }
    });

    // Прокрутка окна
    $window.on('scroll load', function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Параллакс
      parallaxScroll(scrollTop);

      // Поиск
      if ($(this).scrollTop() + $window_height < $footer.offset().top) $search.addClass('fixed');
      else $search.removeClass('fixed');

      // Навигация
      if ($(this).scrollTop() >= $header.offset().top + $header.innerHeight()) $nav.addClass('fixed');
      else $nav.removeClass('fixed');
    });

    // Отправка формы
    $body.on('submit', '[data-submit]', function () {
      let data = $(this).data('submit');

      for (let selector in data) {
        if (data[selector].class) $(selector).toggleClass(data[selector].class);
        if (data[selector].toggle == 'slide') $(selector).slideToggle('fast');
        if (data[selector].toggle == 'fade') $(selector).fadeToggle('fast');
        if (data[selector].text) $(selector).text(data[selector].text);
        if (data[selector].scroll) {
          let offset = $(selector).offset().top;
          $body.animate({ scrollTop: offset }, 'fast');
        }
      }
    });

    // Мобильная навигация
    $('.nav-mobile').on('click');

    // Отправить форму фильта по изменению значений
    if ($('.filter').length) {
      $body.on('change', '.filter input', function () {
        let form = $(this).parents('form'),
          Param = form.find('[name=\'srch[Param]\']:checked').val() || 'all';

        $(this).parents('form').attr('action', form.attr('action') + Param + '/#filter-result').submit();
      });
    }

    $('.filter-auto .slider-range').each(function (index, element) {
      let $this = $(element),
        data = $this.data('array');

      $this.slider({
        range: true,
        min: parseFloat(data.min),
        max: parseFloat(data.max),
        step: parseFloat(data.step),
        values: [parseFloat(data.min), parseFloat(data.max)],
        slide: function (event, ui) {
          $this.parents('.item').find('.input .min').val(ui.values[0]);
          $this.parents('.item').find('.input .max').val(ui.values[1]);
          $this.parents('.item').find('.range .min').text(ui.values[0]);
          $this.parents('.item').find('.range .max').text(ui.values[1]);
        },
        stop: function () {
          $this.parents('form').submit();
        },
      });
    });

    $('form.nc_search input.search_query').each(function (index, element) {
      let $this = $(element);

      $this.autocomplete({
        appendTo: $this.data('search'),
        minLength: 3,
        source: '/netcat/modules/search/suggest/title.php?language=ru',
        select: function (event, ui) { window.location = ui.item.url; },
        search: function () {
          if (/(\w+:|\()/.test($(this).val())) {
            return false;
          }
        },
      });
    });

    // Паралакс
    function parallaxScroll(scrolled) {
      let speed = .4,
        parallax = document.getElementsByClassName('parallax');

      $('.parallax').each(function (index, element) {
        element = $(element);
        // parallax[index].style.backgroundPosition = "center "+(-element.offset().top * speed + (scrolled * speed))+"px";
        parallax[index].style.backgroundPosition = 'center ' + ((element.offset().top + 400 - $window_height) * speed - (scrolled * speed)) + 'px';
      });
    }

    $('.js--search-catalog').autocomplete({
      source: '/zapchasti/iveco/search/?isNaked=1',
      minLength: 2,
    });

    $('.js--datepicker').datepicker().on('changeDate load', function (e) {
      console.log(e.date);
      $.ajax({
        url: '/zapchasti/iveco/price.html',
        type: 'GET',
        data: { isNaked: 1, date: e.date.toUTCString(), nc_ctpl: 190 },
        success: function (response) {
          $('.js--datepicker--content').html(response);
        },
      });
    });

  });
})(jQuery);

// Маски
function mask() {
  $('[data-mask=phone]').mask('+7(999) 999-9999');
}

// Действия
function actions(data, $this, serialize) {

  for (let selector in data) {
    let $selector = $(selector);

    if (data[selector].class) $selector.toggleClass(data[selector].class);
    if (data[selector].removeClass) $selector.removeClass(data[selector].removeClass);
    if (data[selector].addClass) $selector.addClass(data[selector].addClass);
    if (data[selector].click == 'true') $selector.click();
    if (data[selector].text) $selector.text(data[selector].text);
    if (data[selector].remove) $selector.remove();
    if (data[selector].removeAttr) $selector.removeAttr(data[selector].removeAttr);
    if (data[selector].siblings) {
      if (data[selector].siblings.class) $selector.addClass(data[selector].siblings.class).siblings().removeClass(data[selector].siblings.class);
    }
    if (data[selector].alignTop) $(selector).css({
      'margin-top': ($(window).height() - $(selector).innerHeight()) / 2 + 'px',
    });
    if (data[selector].poscursor) $(selector).css({
      'top': $($this).offset().top + $($this).outerHeight() / 2 - $(selector).height() / 2 + 'px',
      'left': $($this).offset().left + $($this).outerWidth() + 40 + 'px',
    });
    if (data[selector].toggle) {
      switch (data[selector].toggle) {
        case 'slide':
          $selector.slideToggle('fast');
          break;
        case 'slideUp':
          $selector.slideUp('fast');
          break;
        case 'slideDown':
          $selector.slideDown('fast');
          break;
        case 'fade':
          $selector.fadeToggle('fast');
          break;
        case 'fadeIn':
          $selector.fadeIn('fast');
          break;
        case 'fadeOut':
          $selector.fadeOut('fast');
          break;
      }
    }
    if (data[selector].scroll) {
      let offset = $selector.offset().top;
      if (data[selector].scroll != 'true') offset = $selector.offset().top - parseInt(data[selector].scroll);
      $('html, body').animate({ scrollTop: offset });
    }
    console.log(data[selector].ajax);
    if (data[selector].ajax) {
      let url = (data[selector].ajax.url ? data[selector].ajax.url : $($this).attr('href'));
      if (serialize) url = url + '?' + serialize;

      console.log(data[selector].ajax);

      $.ajax({
        url: url,
        async: false,
        type: (data[selector].ajax.type ? data[selector].ajax.type : 'GET'),
        data: data[selector].ajax.data ? data[selector].ajax.data : { isNaked: 1 },
        success: function (response) {
          if (data[selector].ajax.selector === 'this') $selector.html(response);
          else {
            if ($(data[selector].ajax.selector).length) $(data[selector].ajax.selector).html(response);
          }

          form_validate();
          mask();
          setTimeout(function () {
            onloadCallback();
          }, 1000);
        },
      });
    }
  }
}

// Проверка форм
function form_validate() {
  $('form.validate:not(.active)').each(function (index, element) {
    let array = { warnText: null, response: null };

    array = $(element).data('array') || array;
    $(element).addClass('active').validate({
      // Форма заполнена не верно
      invalidHandler: function () {
        $(element).ajaxSubmit({
          data: { isNaked: 1 },
          success: function (response, status, xhr, Form) {
            var
              warnText = $(response).filter('.warnText'),
              all = $(response);

            if (warnText.length && warnText.length !== 'false') {
              if (array.warnText != null) $(array.warnText).html(warnText);
              else $(Form).find('.warnText').html(warnText);
            } else {
              if (array.warnText != null) $(array.warnText).html(all);
              else $(Form).find('.warnText').html(all);
            }
          },
        });
      },
      // Форма заполнена верно
      submitHandler: function (form) {
        if (array.ajax !== 'false') {
          $(form).ajaxSubmit({
            data: { isNaked: 1 },
            success: function (response, status, xhr, Form) {
              var
                resp = ($(response).filter('.response').length ? $(response).filter('.response') : $(response).find('.response')),
                warnText = ($(response).filter('#nc_modal_status').length ? $(response).filter('#nc_modal_status') : $(response).find('#nc_modal_status')),
                all = $(response);

              if (warnText.length) {
                if (warnText.length && warnText.length !== 'false') {
                  if (array.warnText != null) $(array.warnText).html(warnText);
                  else $(Form).find('.warnText').html(warnText);
                } else {
                  if (array.warnText != null) $(array.warnText).html(all);
                  else $(Form).find('.warnText').html(all);
                }
              } else {
                if (resp.length && resp.length !== 'false') {
                  if (array.response) $(array.response).html(resp);
                  else $(Form).closest('div').html(resp);
                } else {
                  if (array.response) $(array.response).html(all);
                  else $(Form).find('div').html(all);
                }
              }
              mask();
              form_validate();
            },
          });
        }
      },
    });
  });
}

(function (doc) {

  let addEvent = 'addEventListener',
    type = 'gesturestart',
    qsa = 'querySelectorAll',
    scales = [1, 1],
    meta = qsa in doc ? doc[qsa]('meta[name=viewport]') : [];

  function fix() {
    meta.content = 'width=device-width,minimum-scale=' + scales[0] + ',maximum-scale=' + scales[1];
    doc.removeEventListener(type, fix, true);
  }

  if ((meta = meta[meta.length - 1]) && addEvent in doc) {
    fix();
    scales = [.25, 1.6];
    doc[addEvent](type, fix, true);
  }

}(document));

let onloadCallback = function () {
  mysitekey = '6Le_YhsUAAAAABHcNavYoqgo9_6OiqzqA4VFE0i3';

  $('.recaptcha').each(function (index, element) {
    let $this = $(element);

    grecaptcha.render($this.attr('id'), {
      'sitekey': mysitekey,
    });
  });
};
